import React from 'react';
import { Colors } from '../../constants';
import { useTranslation } from 'react-i18next';

const ConfirmButton = ({ confirmButtonOnClick, color = `#${Colors.primaryColor}`, disabled, type = 'button', cancelMeeting, showCancelButton = false, isShareDateTime = false, isShowTimingList = false, shareTimings = {}, dateSelected = null, showPreviewShare, previewShare = false, backFromShowPreview }) => {
  const { t } = useTranslation();

  let check_share = false;
  let key = '';
  if (isShareDateTime && isShowTimingList && !disabled) {
    let date = new Date(dateSelected);
    if (date) {
      key = `${date.getDate()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${date.getFullYear()}`;
      if (!shareTimings[key]) {
        check_share = true;
      }
    }
  }



  return(
    <div className="button-confirm-fixed">
      <button 
        type={type}
        form={type === 'submit' ? 'form-submit' : undefined}
        style={{ backgroundColor: `${disabled ? `#${Colors.disabledButton}` : (color)}`}} 
        onClick={ type === 'button' ?  () => {confirmButtonOnClick()} : undefined}
        onTouchStart={ type === 'button' ?  () => {confirmButtonOnClick()} : undefined}
        // onSubmit={ type === 'submit' ? (event) => {confirmButtonOnClick(event)} : undefined }
        disabled={disabled} >
        { (check_share) ? t('Back') : (previewShare ? t('Copy to Clipboard') : t('Confirm')) }
      </button>

      { showCancelButton && (
        <div className="cancel-meeting-wrap">
          <div className="cancel-button">
            <button style={{ color: color }} onClick={() => cancelMeeting(true, false)}>{t('Cancel Meeting')}</button>
          </div>
        </div>
      )}

      { !isShowTimingList && isShareDateTime && !previewShare && (
        <div className="cancel-meeting-wrap">
          <div className="cancel-button">
            <button
              type={'button'}
              style={{ color: Object.keys(shareTimings).length === 0 ? `#${Colors.gray}` : color }}
              onClick={() => showPreviewShare()}
              onTouchStart={() => showPreviewShare()}
              disabled={Object.keys(shareTimings).length === 0}>
                {t('Show Preview')}
            </button>
          </div>
        </div>
      )}

      { previewShare && (
        <div className="cancel-meeting-wrap">
          <div className="cancel-button">
            <button
              type={'button'}
              style={{ color: color }}
              onClick={() => backFromShowPreview()}
              onTouchStart={() => backFromShowPreview()}>
                {t('Back')}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfirmButton;